import * as React from 'react'

function LinkedInMinimalSvg(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 25" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.10121 0.0070408H22.5562C23.0213 0.00110343 23.4697 0.179919 23.803 0.504242C24.1364 0.828565 24.3274 1.2719 24.3343 1.73694V22.2734C24.3314 22.504 24.2831 22.7318 24.1921 22.9437C24.1012 23.1556 23.9694 23.3475 23.8043 23.5085C23.6392 23.6695 23.444 23.7964 23.2299 23.8819C23.0157 23.9675 22.7868 24.01 22.5562 24.007H2.10121C1.87111 24.0095 1.64279 23.9666 1.42928 23.8808C1.21576 23.795 1.02124 23.668 0.856819 23.507C0.692397 23.346 0.561296 23.1542 0.471001 22.9426C0.380706 22.7309 0.332986 22.5035 0.330566 22.2734V1.73694C0.336427 1.27288 0.526156 0.83011 0.858116 0.50579C1.19008 0.181469 1.63715 0.00209797 2.10121 0.0070408ZM7.73173 5.37479C7.73173 6.51431 6.80797 7.43807 5.66845 7.43807C4.52893 7.43807 3.60517 6.51431 3.60517 5.37479C3.60517 4.23527 4.52893 3.31151 5.66845 3.31151C6.80797 3.31151 7.73173 4.23527 7.73173 5.37479ZM7.44649 9.00498H3.88669V20.4549H7.44649V9.00498ZM20.7819 20.4697V14.1724C20.7819 11.0905 20.1151 8.71975 16.5071 8.71605C15.8308 8.69097 15.1603 8.85001 14.5673 9.17621C13.9742 9.50241 13.4809 9.98352 13.14 10.5682H13.0918V9.00498H9.68016V20.4549H13.2363V14.817C13.2363 13.3242 13.54 11.8758 15.3699 11.8758C17.1998 11.8758 17.2221 13.5872 17.2221 14.9133V20.4697H20.7819Z"
        fill={props.fill || '#111111'}
      />
    </svg>
  )
}

export const LinkedInMinimal = React.memo(LinkedInMinimalSvg)

function LinkedInSvg(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M22.2257 -0.000222942H1.77064C1.30658 -0.00516578 0.859509 0.174206 0.527549 0.498526C0.19559 0.822846 0.00586067 1.26562 0 1.72967L0 22.2662C0.00241944 22.4963 0.0501392 22.7236 0.140434 22.9353C0.230729 23.1469 0.361831 23.3387 0.526253 23.4997C0.690675 23.6607 0.885197 23.7877 1.09871 23.8735C1.31222 23.9593 1.54055 24.0022 1.77064 23.9998H22.2257C22.4562 24.0027 22.6851 23.9602 22.8993 23.8747C23.1134 23.7891 23.3086 23.6622 23.4738 23.5013C23.6389 23.3403 23.7707 23.1483 23.8616 22.9364C23.9525 22.7245 24.0008 22.4968 24.0037 22.2662V1.72967C23.9969 1.26463 23.8058 0.821302 23.4725 0.496979C23.1391 0.172656 22.6907 -0.00616032 22.2257 -0.000222942Z"
          fill="#0A66C2"
        />
        <path
          d="M5.33794 7.43079C6.47746 7.43079 7.40122 6.50703 7.40122 5.36751C7.40122 4.22799 6.47746 3.30423 5.33794 3.30423C4.19842 3.30423 3.27466 4.22799 3.27466 5.36751C3.27466 6.50703 4.19842 7.43079 5.33794 7.43079Z"
          fill="white"
        />
        <path d="M7.11596 8.99771H3.55615V20.4476H7.11596V8.99771Z" fill="white" />
        <path
          d="M20.4513 14.1652V20.4624H16.8915V14.906C16.8915 13.5799 16.8693 11.8685 15.0394 11.8685C13.2095 11.8685 12.9057 13.3169 12.9057 14.8097V20.4476H9.34961V8.99771H12.7612V10.5609H12.8094C13.1504 9.97625 13.6437 9.49514 14.2367 9.16894C14.8298 8.84274 15.5002 8.68369 16.1766 8.70877C19.7846 8.71248 20.4513 11.0832 20.4513 14.1652Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LinkedIn = React.memo(LinkedInSvg)

function LinkedInColorSvg(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 33 33" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M30.56 0H2.435A2.41 2.41 0 000 2.378v28.238A2.41 2.41 0 002.435 33H30.56a2.413 2.413 0 002.445-2.384V2.378A2.414 2.414 0 0030.56 0z"
          fill="#0A66C2"
        />
        <path
          d="M7.34 10.217a2.837 2.837 0 100-5.674 2.837 2.837 0 000 5.674zM9.784 12.372H4.89v15.744h4.894V12.372zM28.12 19.477v8.659h-4.894v-7.64c0-1.824-.03-4.177-2.547-4.177-2.516 0-2.934 1.992-2.934 4.044v7.753h-4.89V12.372h4.692v2.15h.066a5.14 5.14 0 014.63-2.547c4.96.005 5.878 3.264 5.878 7.502z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h33v33H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LinkedInColor = React.memo(LinkedInColorSvg)
